import { del, get, post, put, urlApiTegra } from "../../../service/api";

const url = urlApiTegra;


async function getJobRoles(token: string) {
    return get(`${url}/jobs`, token)
}

async function postJobRoles (body: any, token: string ) {
    return post(`${url}/jobs`, body,  token) 
}

async function delJobRoles (id: number, token: string) {
    return del(`${url}/jobs/${id}`, token)
}

async function putJobRoles(body: any, id: number, token: string) {
    return put(`${url}/jobs/${id}`, body, token)
}

export {
    postJobRoles,
    getJobRoles,
    delJobRoles,
    putJobRoles,
}